/**
 * The following views use this script:
 * /View/Commerce/Checkout/CheckoutAdditionalConsents.cshtml
 * /View/Commerce/Checkout/CheckoutEnroll.cshtml
**/

import {initToggle, watchToggleStateChanges} from './toggle-content';

$(function () {
    watchToggleStateChanges();
    initToggle();
});
